(function () {
  if (window.__sidecartRecLoaded) return;
  window.__sidecartRecLoaded = true;

  // ─── Constants ───────────────────────────────────────────────────────────────

  const CONFIG = {
    observeId:      'CartContainer',
    injectionClass: 'sidecart-rec-injected',
    cartDataUrl:    '/cart.js',
    recApiUrl:      '/recommendations/products.json',
    addToCartUrl:   '/cart/add.js',
  };

  const TITLE_STRIP_KEYWORDS = ['Jigsaw'];

  // ─── State ────────────────────────────────────────────────────────────────────

  let isProcessing = false;
  let pendingRun   = false;

  // ─── Data Fetchers ────────────────────────────────────────────────────────────

  async function fetchCart() {
    const res = await fetch(CONFIG.cartDataUrl);
    return res.json();
  }

  async function fetchRecommendedProducts(productId) {
    const res = await fetch(`${CONFIG.recApiUrl}?product_id=${productId}&limit=10`);
    const data = await res.json();
    return data.products || [];
  }

  function getPinnedProducts() {
    const el = document.getElementById('sidecart-pinned-products');
    if (!el) return [];
    try {
      const data = JSON.parse(el.textContent);
      return data.enabled ? data.products : [];
    } catch (e) {
      console.error('Failed to parse pinned products JSON', e);
      return [];
    }
  }

  // ─── Helpers ──────────────────────────────────────────────────────────────────

  function filterTitle(title) {
    return TITLE_STRIP_KEYWORDS
      .reduce((t, kw) => t.replace(new RegExp(kw, 'gi'), ''), title)
      .trim();
  }

  function formatCurrency(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function formatBoughtNumber(raw) {
    const n = Number(raw);
    if (n >= 1000) return `${Math.floor(n / 1000)}k+`;
    if (n >= 100)  return `${Math.floor(n / 100) * 100}+`;
    return n;
  }

  function getProductImage(product) {
    return product.product_image
      || (window.sidecartProductImageMap?.[product.id])
      || product.featured_image
      || product.image;
  }

  function optimizeImageUrl(url, width = 300) {
    return url.includes('?')
      ? `${url}&width=${width}&format=webp`
      : `${url}?width=${width}&format=webp`;
  }

  // ─── HTML Templates ───────────────────────────────────────────────────────────

  function renderStars(product) {
    const meta        = window.sidecartProductMeta?.[product.id] || {};
    const starRating  = product.star_rating  || meta.star_rating;
    const numReviews  = product.num_reviews  || meta.num_reviews;

    if (!starRating || !window.sidecartStarsAssetUrl) return '';

    const imgSrc    = window.sidecartStarsAssetUrl.replace('number', starRating);
    const reviewsHtml = numReviews ? `<span class="sidecart-rec-reviews">(${numReviews})</span>` : '';
    return `<b class="sidecart-rec-stars-label">${starRating}</b><img src="${imgSrc}" class="sidecart-rec-stars" alt="${starRating} stars">${reviewsHtml}`;
  }

  function renderBanner(product) {
    const meta          = window.sidecartProductMeta?.[product.id] || {};
    const boughtLastMonth = product.bought_last_month || meta.bought_last_month;
    if (!boughtLastMonth) return '';

    const display = formatBoughtNumber(boughtLastMonth);
    return `<div class="sidecart-rec-banner"><b>${display}</b> units sold in the last 90 days</div>`;
  }

  function renderCardInner(product) {
    const img          = getProductImage(product);
    const variants     = product.variants || [];
    const firstVariant = variants[0];
    const basePrice    = product.price || firstVariant?.price || 0;
    const price        = product.priceFormatted || formatCurrency(basePrice);
    const vId          = product.variantId || firstVariant?.id;
    const hasVariants  = variants.length > 1;

    const variantPickerHtml = hasVariants ? `
      <div class="sidecart-rec-variant-picker">
        <div class="sidecart-rec-variant-trigger">
          <span class="sidecart-rec-variant-label">${firstVariant?.title || 'Select option'}</span>
          <svg class="sidecart-rec-variant-chevron" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 12 12"><path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <div class="sidecart-rec-variant-panel">
          ${variants.map((v, i) => `<div class="sidecart-rec-variant-opt${i === 0 ? ' active' : ''}" data-variant-id="${v.id}" data-price="${v.price}">${v.title}</div>`).join('')}
        </div>
      </div>` : '';

    return `
      ${renderBanner(product)}
      <div class="sidecart-rec-image-wrap">
        <img
          src="${optimizeImageUrl(img)}"
          class="sidecart-rec-image"
          alt="${filterTitle(product.title)}"
        >
      </div>
      <div class="sidecart-rec-card-row">
        <div class="sidecart-rec-info">
          <div class="sidecart-rec-product-title">${filterTitle(product.title)}</div>
          <div class="sidecart-rec-ratings-wrapper">${renderStars(product)}</div>
          <div class="sidecart-rec-price">${price}</div>
        </div>
      </div>
      <div class="sidecart-rec-card-bottom">
        <div class="sidecart-rec-card-bottom-inner">
          ${variantPickerHtml}
          <button type="button" class="sidecart-rec-btn" data-variant-id="${vId}">Add to Cart</button>
        </div>
      </div>
    `;
  }

  // ─── DOM Builders ─────────────────────────────────────────────────────────────

  function buildCardElement(product) {
    const heroBg = window.sidecartHeroBgMap?.[product.id] || product.hero_bg;
    const heroBgSmall  = heroBg ? optimizeImageUrl(heroBg, 400) : null;
    const skeletonClass = heroBgSmall ? ' sidecart-rec-skeleton' : '';

    const wrapper = document.createElement('div');
    wrapper.className = CONFIG.injectionClass;
    wrapper.innerHTML = `
      <div class="sidecart-rec-flex${skeletonClass}">
        ${renderCardInner(product)}
      </div>
    `;

    if (heroBgSmall) {
      lazyLoadBackground(wrapper.querySelector('.sidecart-rec-flex'), heroBgSmall);
    }

    return wrapper;
  }

  function lazyLoadBackground(flexEl, url) {
    const img = new Image();
    img.onload = () => {
      flexEl.style.backgroundImage = `url(${url})`;
      flexEl.classList.remove('sidecart-rec-skeleton');

      // Lock background to expanded-card dimensions so it never shifts on open/close.
      const W = flexEl.offsetWidth;
      const collapseH = flexEl.offsetHeight;

      const cardBottom = flexEl.querySelector('.sidecart-rec-card-bottom');
      const cardBottomH = cardBottom ? cardBottom.scrollHeight : 0;

      const expandedH = collapseH + cardBottomH;

      const scale = Math.max(W / img.naturalWidth, expandedH / img.naturalHeight);
      const bgW = img.naturalWidth * scale;
      const bgH = img.naturalHeight * scale;
      const bgX = Math.round((W - bgW) / 2);
      const bgY = Math.round((expandedH - bgH) / 2);

      flexEl.style.backgroundSize = bgW + 'px ' + bgH + 'px';
      flexEl.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
    };
    img.src = url;
  }

  // ─── Event Wiring ─────────────────────────────────────────────────────────────

  function wireVariantSelect(container) {
    // variant picker inside card-bottom
    const picker  = container.querySelector('.sidecart-rec-variant-picker');
    if (!picker) return;

    const pTrigger = picker.querySelector('.sidecart-rec-variant-trigger');
    const pPanel   = picker.querySelector('.sidecart-rec-variant-panel');
    const pLabel   = picker.querySelector('.sidecart-rec-variant-label');
    const btn      = container.querySelector('.sidecart-rec-btn');
    const priceEl  = container.querySelector('.sidecart-rec-price');

    pTrigger.addEventListener('click', e => {
      e.stopPropagation();
      picker.classList.toggle('open');
    });

    pPanel?.querySelectorAll('.sidecart-rec-variant-opt').forEach(opt => {
      opt.addEventListener('click', e => {
        e.stopPropagation();
        pPanel.querySelectorAll('.sidecart-rec-variant-opt').forEach(o => o.classList.remove('active'));
        opt.classList.add('active');
        pLabel.textContent    = opt.textContent;
        btn.dataset.variantId = opt.dataset.variantId;
        if (opt.dataset.price) priceEl.textContent = formatCurrency(parseInt(opt.dataset.price));
        picker.classList.remove('open');
      });
    });

    document.addEventListener('click', e => {
      if (!picker.contains(e.target)) picker.classList.remove('open');
    });
  }

  function wireAddToCartButton(container, product) {
    const btn = container.querySelector('.sidecart-rec-btn');

    btn.addEventListener('click', async function () {
      const variantId = btn.dataset.variantId || product.variantId;
      const original  = btn.textContent;

      btn.disabled    = true;
      btn.textContent = 'Adding…';

      try {
        await addToCart(variantId);
        btn.textContent = 'Added ✓';
        btn.classList.add('added');
        setTimeout(() => {
          btn.textContent = original;
          btn.classList.remove('added');
          btn.disabled    = false;
        }, 1400);
      } catch {
        btn.textContent = original;
        btn.disabled    = false;
      }
    });
  }

  // ─── Cart Actions ─────────────────────────────────────────────────────────────

  async function addToCart(variantId, sellingPlanId) {
    const payload = { id: variantId, quantity: 1 };
    if (sellingPlanId) payload.selling_plan = sellingPlanId;

    const res = await fetch(CONFIG.addToCartUrl, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload),
    });

    if (!res.ok) throw new Error('Add to cart failed');
    refreshCartUI(variantId);
  }

  window.handleRecAddToCart = addToCart;

  function refreshCartUI(variantId) {
    if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
      ajaxCart.load();
    } else {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { variantId } }));
      if (window.jQuery) {
        jQuery(document).trigger('change');
        jQuery(document.body).trigger('added.ajaxcart');
      }
    }
  }

  // ─── Product Selection Logic ──────────────────────────────────────────────────

  function selectPinnedProduct(pinnedProducts, cartItems) {
    return pinnedProducts.find(p => !cartItems.some(item => item.product_id == p.id)) || null;
  }

  async function selectRecommendedProduct(cartItems, pinnedProducts) {
    const seedItems = cartItems.slice(0, 4);
    const results   = await Promise.all(seedItems.map(item => fetchRecommendedProducts(item.product_id)));

    const freq = {};
    results.flat().forEach(rec => {
      if (!freq[rec.id]) freq[rec.id] = { count: 0, product: rec };
      freq[rec.id].count++;
    });

    const ranked = Object.values(freq)
      .sort((a, b) => b.count - a.count)
      .map(e => e.product);

    const selected = ranked.find(rec =>
      rec.vendor === 'Jigsaw Health' &&
      !cartItems.some(item => item.product_id == rec.id)
    ) || null;

    if (selected && !selected.hero_bg) {
      const pinnedMatch = pinnedProducts.find(p => p.id == selected.id);
      if (pinnedMatch?.hero_bg) selected.hero_bg = pinnedMatch.hero_bg;
    }

    return selected;
  }

  // ─── DOM Injection ────────────────────────────────────────────────────────────

  function injectRecommendation(cartContainer, product) {
    console.log('[sidecart-rec] recommended product:', product);
    const cartItems = cartContainer.querySelectorAll('.ajaxcart__product');
    const innerDiv  = cartContainer.querySelector('.ajaxcart__inner');

    if (!cartItems.length && !innerDiv) return;

    const card = buildCardElement(product);
    wireVariantSelect(card);
    wireAddToCartButton(card, product);

    if (cartItems.length) {
      cartItems[cartItems.length - 1].insertAdjacentElement('afterend', card);
    } else {
      const quoteEl = innerDiv?.querySelector('.ajaxcart__social-proof');
      if (quoteEl) quoteEl.insertAdjacentElement('afterend', card);
      else if (innerDiv) innerDiv.appendChild(card);
    }
  }

  // ─── Engine ───────────────────────────────────────────────────────────────────

  async function runRecommendationEngine() {
    const cartContainer = document.getElementById(CONFIG.observeId);
    if (!cartContainer) return;
    if (isProcessing) { pendingRun = true; return; }

    isProcessing = true;
    pendingRun   = false;

    try {
      const cart           = await fetchCart();
      const pinnedProducts = getPinnedProducts();

      if (cart.item_count === 0 && pinnedProducts.length === 0) {
        cartContainer.querySelector('.' + CONFIG.injectionClass)?.remove();
        return;
      }

      if (cartContainer.querySelector('.' + CONFIG.injectionClass)) return;

      const selectedProduct =
        selectPinnedProduct(pinnedProducts, cart.items) ||
        (cart.items.length ? await selectRecommendedProduct(cart.items, pinnedProducts) : null);

      if (selectedProduct) {
        injectRecommendation(cartContainer, selectedProduct);
      }
    } catch (e) {
      console.error('Sidecart recommendation engine error:', e);
    } finally {
      isProcessing = false;
      if (pendingRun) setTimeout(runRecommendationEngine, 50);
    }
  }

  // ─── Cart Title Cleanup ───────────────────────────────────────────────────────

  function filterCartTitles() {
    document.querySelectorAll('.ajaxcart__product-name').forEach(el => {
      el.textContent = filterTitle(el.textContent);
    });
  }

  // ─── Observer & Init ─────────────────────────────────────────────────────────

  function onCartMutation(mutations) {
    const ownClasses = [CONFIG.injectionClass, 'sidecart-item-toggle'];
    const hasExternalChanges = mutations.some(m =>
      m.type === 'childList' &&
      Array.from(m.addedNodes).some(n =>
        n.classList && !ownClasses.some(cls => n.classList.contains(cls))
      )
    );

    if (hasExternalChanges) {
      setTimeout(() => {
        filterCartTitles();
        runRecommendationEngine();
      }, 50);
    }
  }

  function init() {
    const target = document.getElementById(CONFIG.observeId);
    if (!target) return;

    new MutationObserver(onCartMutation).observe(target, { childList: true, subtree: true });
    filterCartTitles();
    runRecommendationEngine();
  }

  init();
})();
